import React, { FC } from "react";
import { useIntl } from "react-intl";
import { Tooltip } from "antd";
import styles from "./appointment-request-tag.module.scss";
import { ExclamationOutlined } from "@ant-design/icons";

interface LinkedAppointmentCancelledTagProps {
  singleAppointment?: boolean;
  showIcon?: boolean;
}

export const LinkedAppointmentCancelledTag: FC<
  LinkedAppointmentCancelledTagProps
> = ({ singleAppointment = true, showIcon = true }) => {
  const { formatMessage } = useIntl();
  const color = singleAppointment ? "#6f0404" : "#c2660a";

  return (
    <Tooltip
      open={showIcon ? undefined : false}
      title={
        singleAppointment
          ? formatMessage({
              id: "appointment-request.linked-appointment-cancelled.tooltip.single",
            })
          : formatMessage({
              id: "appointment-request.linked-appointment-cancelled.tooltip.multi",
            })
      }
    >
      <span
        className={styles.appointmentRequestTag}
        style={{
          backgroundColor: color,
          color: "white",
          border: `1px solid ${color?.[1]}`,
        }}
      >
        {showIcon ? (
          <ExclamationOutlined />
        ) : (
          formatMessage({
            id: "appointment-request.linked-appointment-cancelled.status",
          })
        )}
      </span>
    </Tooltip>
  );
};
